import React from 'react'

import { PermissionChecker } from '../../session'
import Content from './Content'
import ControlledModal from '../../../components/modals/ControlledModal'
import FormLoader from './_load/FormLoader'

const FormReplyModal = props => {
  return (
    <ControlledModal width="56rem" {...props}>
      <PermissionChecker module="form" name="new">
        <FormLoader>
          <Content />
        </FormLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default FormReplyModal
